{
  "id": "campaign-045",
  "name": "Misty Acre",
  "seed": "campaign:45",
  "startDir": "W",
  "mowerRule": {
    "kind": "minTier",
    "tier": 0
  },
  "rows": [
    "........RRRR",
    "........RRRR",
    "........____",
    "...,........",
    "..,,,.......",
    "...,y..y....",
    "..x.........",
    "....e..y..y.",
    "....e.......",
    "....e.......",
    "ffff..ffffff",
    ".c.c.c.c.c.c",
    "...........#",
    "....y..y....",
    "............",
    "...........S"
  ],
  "critters": [
    {
      "kind": "rabbit",
      "x": 2,
      "y": 3
    },
    {
      "kind": "rabbit",
      "x": 8,
      "y": 13
    },
    {
      "kind": "squirrel",
      "x": 3,
      "y": 8
    }
  ],
  "pickups": [
    {
      "kind": "gas",
      "x": 7,
      "y": 3
    },
    {
      "kind": "coin",
      "x": 11,
      "y": 2
    },
    {
      "kind": "coin",
      "x": 10,
      "y": 2
    },
    {
      "kind": "coin",
      "x": 8,
      "y": 2
    },
    {
      "kind": "coin",
      "x": 9,
      "y": 2
    },
    {
      "kind": "coin",
      "x": 11,
      "y": 14
    },
    {
      "kind": "coin",
      "x": 6,
      "y": 1
    },
    {
      "kind": "coin",
      "x": 1,
      "y": 0
    }
  ],
  "generatorVersion": 3,
  "level": 45,
  "biome": "farm",
  "par": {
    "reel": 6620,
    "push": 5469,
    "selfPropelled": 4878,
    "tractor": 4685,
    "zeroTurn": 3391,
    "fairway": 2158
  },
  "routeTries": {
    "par": {
      "reel": 8,
      "push": 21,
      "selfPropelled": 17,
      "tractor": 0,
      "zeroTurn": 1,
      "fairway": 21
    }
  }
}
